module.exports = __webpack_public_path__ + "img/default.8a195261.jpg";